var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "cc-stepper-content",
    {
      attrs: { complete: _vm.selected !== null, exit: "pilot_management" },
      on: {
        back: function($event) {
          return _vm.$emit("back")
        },
        complete: function($event) {
          return _vm.setTemplate()
        }
      }
    },
    [
      _c("cc-title", { attrs: { large: "" } }, [
        _vm._v("New Pilot Registration ")
      ]),
      _vm._v(" "),
      _c(
        "h2",
        { staticClass: "heading" },
        [
          _vm._v("\n    UAD IDENT Service\n    "),
          _c("cc-slashes"),
          _vm._v("\n     PRM-ALT QUICK ACCESS SELECTION\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { attrs: { dense: "", justify: "start", align: "center" } },
        [
          _c(
            "v-col",
            [
              _c(
                "div",
                {
                  staticClass: "flavor-text mt-n2",
                  staticStyle: { "font-size": "14px" }
                },
                [
                  _vm._v(
                    "\n        Per the 5017 PRM-ALT Act, the Union Administrative Department's IDENT registration service\n        provides a Quick Access Selection module, created and curated by UAD Armored Cavalary\n        Support. The UAD-ACS NHP staff have generated a selection of Combat Doctrine Templates\n        based on the results of your OHM Health Examination//CR-2 Brain Activity Scan. Each of\n        these templates will populate the remainder of your IDENT Combat Registration with a\n        tailored set of combat-role-optimal responses.\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "v-alert",
                {
                  staticClass: "mt-n1",
                  attrs: { dense: "", outlined: "", color: "accent" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-center stark--text" },
                    [
                      _vm._v(
                        "\n          Selecting a template will complete the New Pilot interface and start your Pilot with a\n          curated set of skills and talents and an outfitted GMS EVEREST mech, tailored to the\n          combat role selected below. All of these selections may be edited at any time through\n          the Pilot and Mech Sheet loadout sections, as well as section headings with the\n          "
                      ),
                      _c("v-icon", { attrs: { color: "accent" } }, [
                        _vm._v("mdi-circle-edit-outline")
                      ]),
                      _vm._v("\n          icon\n        ")
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("b", { staticClass: "caption accent--text mt-n2" }, [
                _vm._v("\n        MECH ART COURTESY OF\n      ")
              ]),
              _vm._v(" "),
              _c("v-img", {
                staticClass: "img-select",
                attrs: {
                  target: "_blank",
                  href: "https://www.retrogrademinis.com/",
                  src: _vm.retrogradeLogo,
                  "max-height": "131px",
                  "max-width": "478px",
                  contain: ""
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mx-6" },
        _vm._l(_vm.templates, function(t) {
          return _c("template-item", {
            key: t.name,
            attrs: { template: t, "is-selected": t === _vm.selected },
            on: {
              select: function($event) {
                _vm.selected = t
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }